import React from 'react'

const ContractIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" fill="none" viewBox="0 0 16 20">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeWidth="2"
			d="M5 3H3a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2h-2M5 3a2 2 0 002 2h2a2 2 0 002-2M5 3a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M5 14h.01"
		></path>
	</svg>
)

export default ContractIcon
